export default{
    main: "acami.io"
}
